import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BenefitDto } from '../../../models/dtos/benefit.dto';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getPartnersRequest from './getPartners.repository';

type InitialState = {
  loading: boolean;
  data?: BenefitDto[];
  error?: ErrorDto;
};
const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getPartners = createAsyncThunk('getPartners', async () => {
  return await getPartnersRequest();
});

const getPartnersSlice = createSlice({
  name: 'getPartners',
  initialState,
  reducers: {
    getPartnersReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPartners.pending, (state) => {
      state.loading = true;
      state.data = undefined;
      state.error = undefined;
    });
    builder.addCase(
      getPartners.fulfilled,
      (state, action: PayloadAction<BenefitDto[]>) => {
        state.loading = false;
        state.data = action.payload;
      }
    );
    builder.addCase(getPartners.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default getPartnersSlice.reducer;
export const { getPartnersReset } = getPartnersSlice.actions;
